function ensureWebSocketURL(url) {
  if (/wss?:\/\//.test(url)) {
    return url
  }

  return window.location.protocol === 'https:'
    ? `wss://${window.location.host}${url}`
    : `ws://${window.location.host}${url}`
}

export default {
  ...window.CONFIG,
  collabEndpoint: ensureWebSocketURL(window.CONFIG.collabEndpoint),
  graphqlSubscriptionsEndpoint: ensureWebSocketURL(
    window.CONFIG.graphqlSubscriptionsEndpoint
  ),
}
